import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import AmbassadorsData from "../AmbassadorsData/AmbassadorsData";

const COPY = {
  title: "Ambassadors Requests",
  subtitle: "You Can See & Edit Detail About Ambassadors",
  searchPlaceholder: "Search Here",
};

const AmbassadorsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } = useAdminList(
    "getUsers",
    "fullName"
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <AmbassadorsData driverData={items} />
    </AdminPage>
  );
};

export default AmbassadorsAdmin;
